import { render, staticRenderFns } from "./traffic_lights_buttons.vue?vue&type=template&id=1591204a&scoped=true&"
import script from "./traffic_lights_buttons.vue?vue&type=script&lang=js&"
export * from "./traffic_lights_buttons.vue?vue&type=script&lang=js&"
import style0 from "./traffic_lights_buttons.vue?vue&type=style&index=0&id=1591204a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591204a",
  null
  
)

export default component.exports